import { Badge } from '@/components/ui/badge'

interface AccountTypeBadgeProps {
  accountType: string
  className?: string
}

export const AccountTypeBadge = ({ accountType, className }: AccountTypeBadgeProps) => {
  const getColorClasses = (type: string) => {
    const normalizedType = type?.toLowerCase().replace('_', ' ')

    switch (normalizedType) {
      case 'customer':
      case 'end user':
        return 'bg-blue-100 text-blue-800 border-blue-300 hover:bg-blue-100'
      case 'distributor':
        return 'bg-purple-100 text-purple-800 border-purple-300 hover:bg-purple-100'
      case 'dealer':
      case 'reseller':
        return 'bg-green-100 text-green-800 border-green-300 hover:bg-green-100'
      case 'warehouse':
        return 'bg-orange-100 text-orange-800 border-orange-300 hover:bg-orange-100'
      case 'super':
      case 'super admin':
        return 'bg-red-100 text-red-800 border-red-300 hover:bg-red-100'
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300 hover:bg-gray-100'
    }
  }

  const getDisplayName = (type: string) => {
    const normalizedType = type?.toLowerCase()

    switch (normalizedType) {
      case 'end_user':
        return 'End User'
      case 'reseller':
        return 'Reseller'
      case 'distributor':
        return 'Distributor'
      case 'warehouse':
        return 'Warehouse'
      case 'super':
        return 'Super Admin'
      case 'customer':
        return 'Customer'
      case 'dealer':
        return 'Dealer'
      default:
        return type?.charAt(0).toUpperCase() + type?.slice(1) || 'Unknown'
    }
  }

  return (
    <Badge variant="outline" className={`${getColorClasses(accountType)} ${className || ''}`}>
      {getDisplayName(accountType)}
    </Badge>
  )
}
